import { getCookieValue, setCookie } from '@/core/utils/cookies.client';
import { createId } from '@/core/utils/string';
import { CORRELATION_ID } from './cookies.config';

export function getCorrelationIdCookie(): Promise<string | null> {
	return getCookieValue(CORRELATION_ID);
}

async function setCorrelationIdCookie(value: string): Promise<void> {
	await setCookie(CORRELATION_ID, value);
}

export async function createCorrelationIdCookie(): Promise<string> {
	const value = createId();
	await setCorrelationIdCookie(value);

	return value;
}

export async function getOrCreateCorrelationIdCookie(): Promise<string> {
	const existing = await getCorrelationIdCookie();

	if (existing) return existing;

	return createCorrelationIdCookie();
}
